import { render, staticRenderFns } from "./FeedbackPanel.vue?vue&type=template&id=2c542c91&scoped=true&"
import script from "./FeedbackPanel.vue?vue&type=script&lang=js&"
export * from "./FeedbackPanel.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackPanel.vue?vue&type=style&index=0&id=2c542c91&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c542c91",
  null
  
)

export default component.exports